import React from 'react'
import { useTranslation } from 'react-i18next'
import { BenefitsSection } from './styles'
import Benefit from './Benefit'

import secure from 'assets/images/wallet/benefits/secure.svg'
import fast from 'assets/images/wallet/benefits/lghtning-fast.svg'
import earn from 'assets/images/wallet/benefits/earn.svg'

interface BenefitsData {
  image: string
  title: string
  description: string
}

const benefitsImages = [secure, fast, earn]

export default function WalletBenefits() {
  const { t } = useTranslation('wallet')
  const benefitsData: BenefitsData[] = t(`benefits`, {
    returnObjects: true,
    defaultValue: [],
  })
  const benefitsWithImages = benefitsData.map((benefit, index) => ({
    ...benefit,
    image: benefitsImages[index],
  }))

  return (
    <BenefitsSection>
      {benefitsWithImages.map((benefitData, index) => (
        <Benefit key={index} {...benefitData} />
      ))}
    </BenefitsSection>
  )
}
